import React from "react";
import type { Positions } from ".";
import { NODE_NAME, TreeNode } from "../../../../stores/catalog-tree-store";
import { NAME_GAP, DERIVATIVES_PADDING, DATA_BUTTONS_GAP } from "./constants";

export const GenomesTreeDataDerivatives = ({
  indexes,
  nodes,
  positions,
  isDerivative,
  getTextLength,
}: {
  indexes: number[];
  nodes: TreeNode[];
  positions: Positions;
  maxTextLength: number;
  getTextLength: (idx: number) => number;
  isDerivative: (idx: number) => boolean;
}) => {
  const names = indexes.map((idx) => nodes[idx][NODE_NAME]);
  if (names.length < 2) {
    return null;
  }

  const groups = groupByDerivatives(indexes, names, isDerivative);
  if (groups.length === 0) {
    return null;
  }

  return (
    <g className="genomes-tree__nodes__derivatives">
      {groups.map((gr) => {
        const maxTextLength = Math.max.apply(
          undefined,
          gr.map((idx) => getTextLength(idx))
        );

        const p0 = positions[gr[0]];
        const p1 = positions[gr[gr.length - 1]];
        const x = p0[0] - DERIVATIVES_PADDING;
        const y0 = p0[1] - DERIVATIVES_PADDING;
        const y1 = p1[1] + DERIVATIVES_PADDING;

        const w = maxTextLength + NAME_GAP + DATA_BUTTONS_GAP - DERIVATIVES_PADDING;
        const h = y1 - y0;
        return <rect key={gr[0]} x={x} y={y0} width={w} height={h} rx="5" />;
      })}
    </g>
  );
};

function groupByDerivatives(
  indexes: number[],
  names: string[],
  isDerivative: (idx: number) => boolean
) {
  const groups: number[][] = [];
  let gr: number[] = [indexes[0]];
  let grMain = names[0];
  for (let i = 1; i < names.length; ++i) {
    if (names[i].indexOf(grMain) !== -1 && isDerivative(indexes[i])) {
      gr.push(indexes[i]);
    } else {
      if (gr.length > 1) {
        groups.push(gr);
      }
      grMain = names[i];
      gr = [indexes[i]];
    }
  }
  if (gr.length > 1) {
    groups.push(gr);
  }

  return groups;
}
